<div class="cx-modal-container" role="dialog" aria-labelledby="dialog-title">
  @if (launchDialogService.data$ | async; as data) {
    <div class="cx-modal-content">
      <!-- Modal Header -->
      <div class="cx-dialog-header modal-header">
        <h4 id="dialog-title" class="title modal-title">
          {{ 'shared.attachments' | cxTranslate }} ({{ data?.images?.length }})
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body">
        @if (selectedImage) {
          <div class="preview">
            <img class="thumbnail__image" [src]="selectedImage.url" alt="" />
          </div>
        }
        <div class="preview-actions">
          <button type="button" class="btn btn-primary btn-small mx-2" (click)="previousImage()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <button type="button" class="btn btn-primary btn-small mx-2" (click)="nextImage()">
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
        <div class="attachments">
          @if (data?.images?.length) {
            <div class="thumbnails">
              @for (image of data?.images; track image; let i = $index) {
                <div
                  class="thumbnail"
                  #thumbnail
                  (click)="showImagePreview(image, i)"
                  [class.selected]="selectedImage?.code == image.code"
                  >
                  <img [src]="getImageUrl(image)" alt="" />
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
